require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-giovanni-buzzi.json") })
        }
      }, "path---en-interviste-giovanni-buzzi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-giovanni-buzzi!./.cache/json/en-interviste-giovanni-buzzi.json
// module id = 582
// module chunks = 231608221292675